import addToCartActionTypes from '../actionTypes/AddToCartActionTypes';

function AddToCartReducer(
    state = { isAddToCartSuccess: false, isUpdateCartSuccess: false },
    action
) {
    switch (action.type) {
        case addToCartActionTypes.ADDTOCART_SITE_REQUEST_SUCCESS:
            return {
                isAddToCartSuccess: true,
                isUpdateCartSuccess: false,
                ppId: action.cartSuccess.ppId,
                skuId: action.cartSuccess.skuId,
                from: action.cartSuccess.from,
            };
        case addToCartActionTypes.ADDTOCART_SITE_REQUEST_ERROR:
            return { isAddToCartSuccess: false, isUpdateCartSuccess: false, error: action.error };
        case addToCartActionTypes.ADDTOCART_SITE_KEEPSHOPPING_ONCLICK:
            return { isAddToCartSuccess: false, isUpdateCartSuccess: false };
        case addToCartActionTypes.ADDTOCART_SITE_RESET:
            return { isAddToCartSuccess: false, isUpdateCartSuccess: false };
        default:
            return state;
    }
}

AddToCartReducer.reducerName = 'addToCartSite';
export default AddToCartReducer;
